import React, { useEffect } from 'react';

import RiskIcon from '../../assets/images/meters/risks.svg';
import ActionIcon from '../../assets/images/meters/actions.svg';
import ControlIcon from '../../assets/images/meters/controls.svg';
import { AiOutlineRadarChart } from "react-icons/ai";

import { connect } from "react-redux";
import { compose } from "redux";

import { getComplianceMetrics } from "../../store/actions/dashboardActions";

const ComplianceMeters = ({ metrics, getComplianceMetricsFN, compliance_id }) => {
    
    useEffect(() => {
        console.log("compliance_id", compliance_id)
        getComplianceMetricsFN(compliance_id);
    }, [compliance_id]);

    return (
        <div className="flex justify-center items-center bg-white p-6 pt-0 pr-0 gap-x-32">
            {/* Compliance Risks */}
            <div className="flex items-center">
                <img
                    src={RiskIcon}
                    alt="Compliance Risks Icon"
                    className="h-10 w-10 mr-2"
                />
                <div className="flex flex-col">
                    <div className="text-xl md:text-lg font-bold">{metrics.risks}</div>
                    <div className="text-lg md:text-lg text-gray-600">Compliance Risks</div>
                </div>
            </div>

            {/* Compliance Controls */}
            <div className="flex items-center">
                <img
                    src={ControlIcon}
                    alt="Compliance Controls Icon"
                    className="h-10 w-10 mr-2"
                />
                <div className="flex flex-col">
                    <div className="text-xl md:text-lg font-bold">{metrics.controls}</div>
                    <div className="text-lg md:text-lg text-gray-600">Compliance Controls</div>
                </div>
            </div>

            {/* Compliance Actions */}
            <div className="flex items-center">
                <img
                    src={ActionIcon}
                    alt="Compliance Actions Icon"
                    className="h-8 w-8 mr-2"
                />
                <div className="flex flex-col">
                    <div className="text-xl md:text-lg font-bold">{metrics.actions}</div>
                    <div className="text-lg md:text-lg text-gray-600">Compliance Actions</div>
                </div>
            </div>

        </div>
    );
};

const mapStateToProps = (state) => {
    console.log("Compince satte", state.dashboard.complianceMetrics)
    return {
        metrics: state.dashboard.complianceMetrics, 
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getComplianceMetricsFN: (c) => dispatch(getComplianceMetrics(c)), 
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(ComplianceMeters);